'use client';
/* eslint-disable no-restricted-imports */
import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';

import Translate from '~/client/shared/i18n/Translate';
import HitRatioRow from './MobileGameDetailsRow/HitRatioRow';
import InLoyaltyRow from './MobileGameDetailsRow/InLoyaltyRow';
import LiveRtp from './MobileGameDetailsRow/LiveRtp';
import MaxBetRow from './MobileGameDetailsRow/MaxBetRow';
import MinBetRow from './MobileGameDetailsRow/MinBetRow';
import PaylinesRow from './MobileGameDetailsRow/PaylinesRow';
import RtpRow from './MobileGameDetailsRow/RtpRow';
import VolatilityRow from './MobileGameDetailsRow/VolatilityRow';

type GameDetailsTableProps = {
  game?: SingleGameFragment;
  hideTitle?: boolean;
};

const MobileGameDetailsTable: FC<GameDetailsTableProps> = ({ game }) => {
  const { minBet, maxBet, rtp, payLines, hitRatio, inLoyalty, volatility } =
    game ?? {};

  if (!game) {
    return null;
  }

  const rows = [
    { key: 'minBet', element: <MinBetRow minBet={minBet} /> },
    { key: 'maxBet', element: <MaxBetRow maxBet={maxBet} /> },
    { key: 'volatility', element: <VolatilityRow volatility={volatility} /> },
    { key: 'paylines', element: <PaylinesRow payLines={payLines} /> },
    { key: 'liveRtp', element: <LiveRtp game={game} /> },
    { key: 'rtp', element: <RtpRow rtp={rtp} /> },
    { key: 'hitRatio', element: <HitRatioRow hitRatio={hitRatio} /> },
    { key: 'inLoyalty', element: <InLoyaltyRow inLoyalty={inLoyalty} /> },
  ];

  return (
    <div className="grid">
      <h2 className="text-4 font-medium text-bulma mb-2">
        <Translate id="casino.game_stats" />
      </h2>

      <div className="grid md:w-max rounded-md bg-gohan">
        {rows.map(({ key, element }) => (
          <div key={key} className="[&_hr]:last:hidden">
            {element}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileGameDetailsTable;
